import axios from 'axios';
import { nextTick } from 'vue';
import {
    scrollAnimate, merge, objectToFormData, areSuggestedAddresses, handleTracking, handleResponseError, getLineItemsGtmData, isDataDomeRedirect, submitOrderConfirm
} from '@/components/helper/util';
import { getLastFormData } from '@/components/helper/formHelper';

const widgetHelper = require('@/scripts/widgetHelper');

var enableGTM = (document.querySelector('.enable_gtm').textContent === 'true');
var enableDY = (document.querySelector('.dy_enable')?.textContent === 'true');

const ABANDONED_STATUS_MAP = {
    login: 'CHECKOUT_LOGIN',
    shipping: 'CHECKOUT_SHIPPING',
    payment: 'CHECKOUT_BILLING'
};

export default {
    state: {
        checkoutLogin: {},
        checkout: {},
        checkoutError: {},
        currentStage: '',
        shippingVars: {
            isaddressFromASmodal: false,
            dataAddressMode: null,
            errors: {},
            loqateInitialized: false,
            selectedHkStore: null,
            selectedHkPickupPointBlockFields: {},
            selectedAddressUUID: null,
            isPickupMethodSelected: null
        },
        billingVars: {
            dataAddressMode: null,
            errors: {},
            lastMethod: '',
            lastCardType: '',
            selectedPaymentMethod: '',
            defaultSelectedPaymentMethod: 'CREDIT_CARD',
            loqateInitialized: false,
            selectedAddressUUID: null
        },
        giftWrappingMessage: '',
        giftWrappingVideo: false,
        giftWrappingMessageChecked: false,
        socialRedirect: false
    },
    getters: {
        checkoutLogin(state) {
            return state.checkoutLogin;
        },
        checkout(state) {
            return state.checkout;
        },
        checkoutError(state) {
            return state.checkoutError;
        },
        shippingVars(state) {
            return state.shippingVars;
        },
        billingVars(state) {
            return state.billingVars;
        },
        currentStage(state) {
            return state.currentStage;
        },
        giftWrappingMessage(state) {
            return state.giftWrappingMessage;
        },
        giftWrappingVideo(state) {
            return state.giftWrappingVideo;
        },
        giftWrappingMessageChecked(state) {
            return state.giftWrappingMessageChecked;
        },
        socialRedirect(state) {
            return state.socialRedirect;
        },
        isSOREnabledInCheckout(state) {
            if (state.checkout.order && state.checkout.order.items) {
                return state.checkout.order.items.items.some((item) => item.SorPeriodicity && item.SorPeriodicity !== undefined && item.SorPeriodicity !== null);
            }
            return false;
        }
    },
    mutations: {
        setGiftWrappingMessage(state, data) {
            state.giftWrappingMessage = data;
        },
        setGiftWrappingVideo(state, data) {
            state.giftWrappingVideo = data;
        },
        setGiftWrappingMessageChecked(state, data) {
            state.giftWrappingMessageChecked = data;
        },
        updateCheckout(state, data) {
            state.checkout = merge(state.checkout, data);
        },
        setCurrentStage(state, data) {
            state.currentStage = data;
        },
        setShippingVars(state, data) {
            state.shippingVars[data.fieldName] = data.fieldValue;
        },
        setBillingVars(state, data) {
            state.billingVars[data.fieldName] = data.fieldValue;
        },
        setCheckoutLogin(state, data) {
            state.checkoutLogin = data;
        },
        setCheckout(state, data) {
            state.checkout = data;

            // TODO: REMOVE DEBUG
            window.pdict = state.checkout;
            if (data && data.order) {
                window.gtm_vars = Object.assign(window.gtm_vars || {}, getLineItemsGtmData(data.order.items.items, data.order.totals));
            }
        },
        handleCheckoutError(state, data) {
            const errorObj = {};
            if (data.errorMessage || (data.serverErrors && data.serverErrors.length > 0)) {
                errorObj.errorMessage = data.errorMessage || '';
                errorObj.serverErrors = data.serverErrors || [];
            }
            state.checkoutError = errorObj;

            nextTick(() => {
                if (Object.values(errorObj).length > 0) {
                    const errorMessageEl = document.getElementsByClassName('error-message');
                    if (errorMessageEl.length > 0) {
                        errorMessageEl[0].style.display = null;
                        scrollAnimate(document.querySelector('.error-message'));
                    }
                }
            });
        },
        setSelectedShippingAddressUUID(state, data) {
            state.shippingVars.selectedAddressUUID = data;
        },
        setSelectedBillingAddressUUID(state, data) {
            state.billingVars.selectedAddressUUID = data;
        },
        setSocialRedirect(state, data) {
            state.socialRedirect = data;
        }
    },
    actions: {
        setCurrentStage({ commit, rootState }, payload) {
            commit('setCurrentStage', payload);
            if (window.vue.customPreferences.abandonedCartEnabled && payload) {
                if ('requestIdleCallback' in window) {
                    requestIdleCallback(() => {
                        axios({
                            method: 'post',
                            url: rootState.actionURLs['AbandonedCart-Update'],
                            data: { status: ABANDONED_STATUS_MAP[payload] },
                            headers: { 'Content-Type': 'application/json; charset=utf-8' }
                        });
                    });
                } else {
                    axios({
                        method: 'post',
                        url: rootState.actionURLs['AbandonedCart-Update'],
                        data: { status: ABANDONED_STATUS_MAP[payload] },
                        headers: { 'Content-Type': 'application/json; charset=utf-8' }
                    });
                }
            }
        },

        login({ commit, rootState, dispatch }, payload) {
            const apiString = rootState.actionURLs['Account-Login'];
            widgetHelper.spinner.start();
            return axios({
                url: apiString,
                method: 'post',
                data: payload
            }).then((response) => {
                let data = response.data;
                commit('handleCheckoutError', {});

                if (!data.success) {
                    throw { response }; // eslint-disable-line no-throw-literal
                } else {
                    if (enableGTM) {
                        document.dispatchEvent(new CustomEvent('gtm:submitLogin', {
                            detail: data
                        }));
                        window.EventEmitter?.emit('submitLogin', {
                            siteLocation: 'Checkout',
                            ...data
                        });
                    }

                    if (enableDY) {
                        dynamicYield.messageOptIn(payload.get('loginEmail'));
                        dynamicYield.identify(data.hashedEmail);
                    }

                    commit('updateFormField', {
                        formName: 'shipping',
                        fieldName: 'email',
                        fieldValue: payload.get('loginEmail')
                    });
                    commit('updateFormField', {
                        formName: 'login',
                        fieldName: 'loginPassword',
                        fieldValue: ''
                    });
                }
                widgetHelper.spinner.stop();
                return { success: true };
            }).catch((error) => handleResponseError(commit, dispatch, error.response));
        },

        getCheckoutLogin({ commit, rootState }) {
            const apiString = `${rootState.actionURLs['Checkout-Login']}`;
            return axios.get(apiString)
                .then((response) => {
                    commit('setCheckoutLogin', response.data);
                })
                .catch(() => { });
        },

        getCheckoutBegin({ commit, rootState, dispatch }) {
            const apiString = `${rootState.actionURLs['Checkout-Get']}`;
            return axios.get(apiString)
                .then((response) => {
                    const data = response.data;

                    commit('handleCheckoutError', {});

                    if (data.error || isDataDomeRedirect(response)) {
                        // eslint-disable-next-line no-throw-literal
                        throw { response };
                    }

                    if (data.serverErrors && data.serverErrors.length > 0) {
                        commit('handleCheckoutError', data);
                    }

                    commit('setCheckout', data);
                    commit('setLastFormData', getLastFormData(data));
                    commit('setSocialRedirect', data.socialRedirect);

                    return {
                        success: true
                    };
                })
                .catch((error) => handleResponseError(commit, dispatch, error.response));
        },

        updateShippingMethodList({ commit, rootState, dispatch }, payload) {
            const apiString = `${rootState.actionURLs['CheckoutShippingServices-UpdateShippingMethodsList']}`;
            widgetHelper.spinner.start();
            return axios({
                method: 'post',
                url: apiString,
                data: payload,
                headers: { 'Content-Type': 'multipart/form-data' }
            })
                .then((response) => {
                    const data = response.data;

                    commit('handleCheckoutError', {});

                    if (data.error || isDataDomeRedirect(response)) {
                        // eslint-disable-next-line no-throw-literal
                        throw { response };
                    }

                    commit('updateCheckout', data);

                    dispatch('getCart', { keepSpinner: false }, { root: true });

                    widgetHelper.spinner.stop();
                })
                .catch((error) => handleResponseError(commit, dispatch, error.response));
        },

        selectShippingMethod({ commit, rootState, dispatch }, payload) {
            const apiString = `${rootState.actionURLs['CheckoutShippingServices-SelectShippingMethod']}`;
            widgetHelper.spinner.start();
            return axios({
                method: 'post',
                url: apiString,
                data: payload,
                headers: { 'Content-Type': 'multipart/form-data' }
            })
                .then((response) => {
                    const data = response.data;

                    commit('handleCheckoutError', {});

                    if (data.error || isDataDomeRedirect(response)) {
                        // eslint-disable-next-line no-throw-literal
                        throw { response };
                    }

                    commit('updateCheckout', data);
                    dispatch('getCart', { keepSpinner: false }, { root: true });

                    widgetHelper.spinner.stop();
                })
                .catch((error) => handleResponseError(commit, dispatch, error.response));
        },

        submitShipping({ commit, rootState, dispatch }, payload) {
            const apiString = `${rootState.actionURLs['CheckoutShippingServices-SubmitShipping']}`;
            widgetHelper.spinner.start();
            return axios({
                method: 'post',
                url: apiString,
                data: payload,
                headers: { 'Content-Type': 'multipart/form-data' }
            })
                .then((response) => {
                    const data = response.data;

                    commit('handleCheckoutError', {});

                    if (data.error || isDataDomeRedirect(response)) {
                        // eslint-disable-next-line no-throw-literal
                        throw { response };
                    }

                    commit('updateCheckout', data);
                    widgetHelper.spinner.stop();

                    let showModal = false;
                    if (areSuggestedAddresses(data)) {
                        showModal = true;
                    } else {
                        commit('setShippingVars', { fieldName: 'isaddressFromASmodal', fieldValue: false });
                        handleTracking(data);
                        document.dispatchEvent(new CustomEvent('handlezerobillingstage', { detail: data }));

                        if (enableGTM) {
                            document.dispatchEvent(new CustomEvent('gtm:addShippingInfo', { detail: data.shippingMethod }));
                            window.EventEmitter?.emit('addShippingInfo', data);
                        }
                    }

                    return {
                        success: true,
                        showModal
                    };
                })
                .catch((error) => {
                    commit('setShippingVars', { fieldName: 'isaddressFromASmodal', fieldValue: false });
                    $('#addressSuggestionModal').modal('hide');
                    return handleResponseError(commit, dispatch, error.response);
                });
        },

        saveShippingAddress({ commit, rootState, dispatch }, payload) {
            const apiString = `${rootState.actionURLs['CheckoutShippingServices-SaveAddress']}`;
            widgetHelper.spinner.start();
            return axios({
                method: 'post',
                url: apiString,
                data: payload.formData,
                headers: { 'Content-Type': 'multipart/form-data' },
                params: {
                    copyShippingAddressToShipment: payload.copyShippingAddressToShipment,
                    ...(payload.addressId ? { addressId: payload.addressId } : {})
                }
            })
                .then((response) => {
                    const data = response.data;

                    commit('handleCheckoutError', {});

                    if (data.error || isDataDomeRedirect(response)) {
                        // eslint-disable-next-line no-throw-literal
                        throw { response };
                    }

                    commit('updateCheckout', data);
                    commit('setSelectedShippingAddressUUID', data.addressInShipment);
                    commit('updateFormField', {
                        formName: 'shipping',
                        fieldName: 'addressId',
                        fieldValue: data.addressId
                    });

                    widgetHelper.spinner.stop();

                    return {
                        success: true
                    };
                })
                .catch((error) => handleResponseError(commit, dispatch, error.response));
        },

        saveBillingAddress({ commit, rootState, dispatch }, payload) {
            const apiString = `${rootState.actionURLs['CheckoutServices-SaveAddress']}`;
            widgetHelper.spinner.start();
            return axios({
                method: 'post',
                url: apiString,
                data: payload.formData,
                headers: { 'Content-Type': 'multipart/form-data' },
                params: {
                    ...(payload.addressId ? { addressId: payload.addressId } : {})
                }
            })
                .then((response) => {
                    const data = response.data;

                    commit('handleCheckoutError', {});

                    if (data.error || isDataDomeRedirect(response)) {
                        // eslint-disable-next-line no-throw-literal
                        throw { response };
                    }

                    commit('updateCheckout', data);
                    commit('setSelectedShippingAddressUUID', data.addressInShipment);
                    commit('setSelectedBillingAddressUUID', data.billingAddressUUID);

                    widgetHelper.spinner.stop();

                    return {
                        success: true
                    };
                })
                .catch((error) => handleResponseError(commit, dispatch, error.response));
        },

        storePaymentMethod({ commit, rootState, dispatch }, payload) {
            commit('setBillingVars', ({ fieldName: 'lastMethod', fieldValue: payload.paymentMethod }));
            commit('setBillingVars', ({ fieldName: 'lastCardType', fieldValue: payload.cardType }));

            const apiString = `${rootState.actionURLs['CheckoutServices-StorePaymentMethod']}`;
            widgetHelper.spinner.start();
            return axios({
                method: 'post',
                url: apiString,
                data: objectToFormData(payload),
                headers: { 'Content-Type': 'multipart/form-data' }
            })
                .then((response) => {
                    const data = response.data;

                    if (data.error || isDataDomeRedirect(response)) {
                        // eslint-disable-next-line no-throw-literal
                        throw { response };
                    }

                    commit('updateCheckout', data);
                    widgetHelper.spinner.stop();
                })
                .catch((error) => handleResponseError(commit, dispatch, error.response));
        },

        submitPayment({ commit, rootState, dispatch }, payload) {
            const apiString = `${rootState.actionURLs['CheckoutServices-SubmitPayment']}`;
            widgetHelper.spinner.start();
            return axios({
                method: 'post',
                url: apiString,
                data: payload,
                headers: { 'Content-Type': 'multipart/form-data' }
            })
                .then((response) => {
                    const data = response.data;

                    commit('handleCheckoutError', {});

                    if (data.error || isDataDomeRedirect(response)) {
                        // eslint-disable-next-line no-throw-literal
                        throw { response };
                    }

                    commit('updateCheckout', data);
                    if (enableGTM) {
                        const paymentMethod = data.order.billing.payment.selectedPaymentInstruments[0].paymentMethod;
                        document.dispatchEvent(new CustomEvent('gtm:addPaymentInfo', {
                            detail: paymentMethod
                        }));
                        window.EventEmitter?.emit('addPaymentInfo', { paymentMethod });
                    }

                    return {
                        success: true
                    };
                })
                .catch((error) => handleResponseError(commit, dispatch, error.response));
        },

        placeOrder({ commit, rootState, dispatch }) {
            const apiString = `${rootState.actionURLs['CheckoutServices-PlaceOrder']}`;
            return axios({
                method: 'post',
                url: apiString
            })
                .then((response) => {
                    const data = response.data;

                    commit('handleCheckoutError', {});

                    if (data.error || isDataDomeRedirect(response)) {
                        // eslint-disable-next-line no-throw-literal
                        throw { response };
                    }

                    commit('updateCheckout', data);

                    if (data.payload) {
                        document.getElementById('externalPaymentFormSubmit').click();
                        return {
                            success: true
                        };
                    }

                    let continueUrl = data.continueUrl;
                    if (data.orderID && data.orderToken) {
                        submitOrderConfirm(continueUrl, data.orderID, data.orderToken, data.points || 0);
                        return {
                            success: true
                        };
                    }

                    window.location.href = continueUrl;

                    return {
                        success: true
                    };
                })
                .catch((error) => handleResponseError(commit, dispatch, error.response));
        },

        // eslint-disable-next-line no-unused-vars
        getCartHF({ commit, rootState }) {
            Promise.all([
                axios.get(rootState.actionURLs['Cart-GetHeader'])
                    .then((response) => {
                        var template = document.createElement('template');
                        template.innerHTML = response.data.trim();

                        var updatedHeader = template.content.querySelector('header');
                        if (!updatedHeader) return;

                        var cachedHeader = document.getElementById('header');
                        if (cachedHeader) {
                            cachedHeader.replaceChildren(...updatedHeader.cloneNode(true).childNodes);
                        } else {
                            updatedHeader.classList.add('d-none');
                            var header = document.getElementById('checkout-header') || document.getElementsByTagName('header')[0];
                            if (header) header.after(updatedHeader);
                        }
                        document.dispatchEvent(new CustomEvent('header:init'));
                    })
                    .catch(() => { }),
                axios.get(rootState.actionURLs['Cart-GetFooter'])
                    .then((response) => {
                        var template = document.createElement('template');
                        template.innerHTML = response.data.trim();

                        var updatedFooter = template.content.querySelector('footer');
                        if (!updatedFooter) return;

                        var cachedFooter = document.getElementById('common-footer');
                        if (cachedFooter) {
                            cachedFooter.replaceChildren(...updatedFooter.cloneNode(true).childNodes);
                        } else {
                            updatedFooter.classList.add('d-none');
                            var footer = document.getElementById('checkout-footer') || document.getElementsByTagName('footer')[0];
                            if (footer) footer.after(updatedFooter);
                        }
                        document.dispatchEvent(new CustomEvent('footer:init'));
                    })
                    .catch(() => { })
            ]).then(() => {
                window.cartHFLoaded = true;
                document.dispatchEvent(new Event('cartHFLoaded'));
            });
        }
    }
};
